import React from "react";

import { parseTags } from "./tagParser";
import { TagMentionRenderer } from "./TagMentionRenderer";

interface TextWithTagsProps {
  content: string;
}

export const TextWithTags = ({ content }: TextWithTagsProps) => {
  const tags = parseTags(content);

  if (tags.length === 0) {
    return content;
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  for (const tagInfo of tags) {
    if (tagInfo.start > lastIndex) {
      parts.push(content.slice(lastIndex, tagInfo.start));
    }

    parts.push(<TagMentionRenderer key={`tag-${tagInfo.start}`} tag={tagInfo.tag} />);

    lastIndex = tagInfo.end;
  }

  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  return <>{parts}</>;
};
